export const enum ReportType {
  Undefined = 0,
  LogYardStatus = 1,
  LogYardPeriod = 2,
  LogYardVehicleMoves = 3,
  LogYardMovedProducts = 4,
  LogYardVehicleStatistics = 5,
}
